import {useEffect, useState} from "react";
import {Row} from "react-bootstrap";
import PropTypes from "prop-types";
import ButtonWithIcon from "./ButtonWithIcon";
import {Icons} from "./Icons.jsx";

const FormRepeater = (props) => {
    const [list, setList] = useState(props.value)

    useEffect(() => {
        setList(props.value)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.value.length > 0, props?.length])


    useEffect(() => {
        props.onChange(list)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [list])

    const addElement = () => {
        setList((list) => [...list, {}])
    }

    const cloneElement = (i, newElement) => {
        const newList = [...list]
        if (newElement) {
            newList.splice(i + 1, 0, newElement)
        } else {
            newList.splice(i + 1, 0, list[i])
        }
        setList(newList)
    }

    const removeElement = (i) => {
        const newList = [...list]
        newList.splice(i, 1)
        setList(newList)
    }


    const setValue = (obj, key, value) => {
        const path = key.split('.');
        const last = path.pop();
        const result = {...obj};
        let current = result;

        path.forEach((elem) => {
            current[elem] = current[elem] ? {...current[elem]} : {};
            current = current[elem];
        });
        current[last] = value;

        return result;
    };


    const setRow = (i) => {
        return (key, value) => {
            const newList = [...list];
            newList[i] = setValue(newList[i], key, value);
            setList(newList);
        };
    };

    const setRowMultiple = (i) => {
        return (updates) => {
            const newList = [...list];
            let updatedRow = { ...newList[i] };
            Object.entries(updates).forEach(([key, value]) => {
                updatedRow = setValue(updatedRow, key, value);
            });
            newList[i] = updatedRow;
            setList(newList);
        };
    };

    if (props.hide) return null;

    return <div>
        {list?.map((row, i) => {
            return <Row key={i} className={props.className}>
                <div className={`${props.noFlex ? '' : 'd-flex'} gap-2 align-items-end w-100`}>
                    <div className={`${props.noFlex ? '' : 'd-flex'} gap-2 align-content-center w-100`}>
                        {props.form(row, setRow(i), i, removeElement, cloneElement, setRowMultiple(i))}    </div>
                    <div>
                        {!props.hideNativeDelete && <div className={`align-self-${props.deleteBtnPos}`}>
                            <ButtonWithIcon
                                text={props.deleteBtnText}
                                onClick={() => removeElement(i)}
                                icon={<Icons.delete/>}
                                title={'usuń'}
                                variant={'danger'}
                            />
                        </div>}
                    </div>
                </div>
            </Row>
        })}
        {!props.hideNativeAdd && <div className={'mt-3 d-flex'}>
            <ButtonWithIcon
                size={'sm'}
                disabled={props.addBtnDisabled}
                onClick={() => addElement()}
                icon={<Icons.add/>}
                text={props.addButtonText}
                title={props.addButtonTitle}
                variant={'primary'}
            />
        </div>}


    </div>
};


FormRepeater.propTypes = {
    form: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any.isRequired,
    deleteBtnPos: PropTypes.oneOf(['start', 'center', 'end']),
    debug: PropTypes.bool,
    addButtonTitle: PropTypes.string,
    addButtonText: PropTypes.string,
    hideNativeDelete: PropTypes.bool,
    hideNativeAdd: PropTypes.bool,
    className: PropTypes.string,
    deleteBtnSize: PropTypes.string,
    addBtnDisabled: PropTypes.bool,
    noFlex: PropTypes.bool,// @ rozszerz na całą szerokość ekranu
    deleteBtnText: PropTypes.string,
    length: PropTypes.number,
    hide: PropTypes.bool,
};


export default FormRepeater